import { reactive } from "vue";
import {base_url} from './mock.js'

export const MintInfoStore = reactive({
    mintInfo: null,

  async fetchMintInfo() {
    const result = await this.getMintInfo();
    this.mintInfo = result;
  },


  async getMintInfo() {
        var e_mail = "";
    var userData = localStorage.getItem("bee_user_login_status", null);
    if (userData != null && userData!=undefined) {
      const user = JSON.parse(userData);
     e_mail = user.user.email;
    }
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', // 如果发送JSON数据
        },
        body: new URLSearchParams({
            action: 'bee_mintInfo',
            _wpnonce: "wp_nonce",
            userInfo: e_mail,
        }),
    };

    const mintInfoBaseData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
    // console.log(mintInfoBaseData);
    let r_data = await mintInfoBaseData.json()
    let wp_data = r_data.data.data;
    let json = JSON.parse(wp_data);
    // console.log(json);
    return json.data;
    
},



async setIncr(sec) {

        var e_mail = "";
    var userData = localStorage.getItem("bee_user_login_status", null);
    if (userData != null && userData!=undefined) {
      const user = JSON.parse(userData);
     e_mail = user.user.email;
    }
  const options = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 
      },
      body: new URLSearchParams({
          action: 'bee_doIncr',
          _wpnonce: "wp_nonce",
          sec: sec,
         userInfo: e_mail,
      }),
  };

  const userInfoData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
//   console.log(userInfoData);
  let r_data = await userInfoData.json()
  let wp_data = r_data.data.data;
  let json = JSON.parse(wp_data);
//   console.log(json.data)

  return json;
   },


   async setPageMint(url) {
        var e_mail = "";
    var userData = localStorage.getItem("bee_user_login_status", null);
    if (userData != null && userData!=undefined) {
      const user = JSON.parse(userData);
     e_mail = user.user.email;
    }
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 
        },
        body: new URLSearchParams({
            action: 'bee_doPageMint',
            _wpnonce: "wp_nonce",
            url: url,
            userInfo: e_mail,
        }),
    };
  
    const userInfoData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
    // console.log(userInfoData);
    let r_data = await userInfoData.json()
    let wp_data = r_data.data.data;
    let json = JSON.parse(wp_data);
    // console.log(json.data)
    return json;
     },




});


